import { informParticipationActionTypes } from 'modules/Taps/components/Situations/components/InformParticipation/redux/informParticipationActions';

const initialState = {
  isStateReady: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case informParticipationActionTypes.INIT_FINISH: {
      return { ...state, isStateReady: true };
    }
    case informParticipationActionTypes.RESET_INITIAL: {
      return { ...initialState };
    }
  }

  return state;
}
